import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: window.Transwest.sentryFrontendDsn,
  environment: window.Transwest.appEnv,
  sampleRate: 0.1,
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Prometheus tracking
    /prometheusintelligencetechnology\.com/i,
  ],
  ignoreErrors: ['Unexpected identifier "pit_'],
});
